export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: '粤腾通信',

    /** 公司名称 */
    name: '广州粤腾通信科技有限公司',
    /** 公司微信 */
    wechat: 'yeatime',
    /** 公司邮箱 */
    email: 'yeatime@126.com',
    /** 公司手机 */
    phone: '18866668888',
    /** 公司电话 */
    tel: '020-66668888',
    /** 公司地址 */
    address: '广州市天河区五山路244号金山轩301房',
    /** 备案号 */
    keepOnRecordIcp: '粤ICP备2021150564号-1',

    /** 百度地图相关信息 */
    BDMapInfo: {
        longitude: 113.35378759604717,
        latitude: 23.149171043012394,
        title: '金山轩',
        address: '广州市天河区五山路244号301房'
    }
}


// WEBPACK FOOTER //
// ./src/config/index.js